import type { ReactNode } from 'react'

import { FlashToasts } from '@/components/flash-toasts'
import { MetaTags } from '@/components/meta-tags'
import { ProductAnalytics } from '@/components/product-analytics'

/** Default Inertia layout for components that require the App page context. */
export default function RootLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <MetaTags />
      <FlashToasts />
      <ProductAnalytics />
      {children}
    </>
  )
}
